// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../../Images/bg/login.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}
.login-container {
  width: 500px;
  position: fixed;
  background: #fff;
  top: 50%;
  border-radius: 10px;
  box-shadow: 1px 3px 20px 4px #00000012;
  left: 50%;
  padding: 90px 30px;
  transform: translate(-50%, -50%);
}
.logo-container {
  width: 200px;

  margin: 0 auto;
  margin-bottom: 30px;
}
.logo-container img {
  max-width: 100%;
}
.button-container {
  margin-top: 30px;
}
.button-container button {
  color: #fff;
  width: 100%;
  border-radius: 7px;
  font-size: 18px;
  height: 50px;
  background: #45bd5b;
}
.form-container input {
  border: 2px solid rgba(230,230,230,1);
  background: #efefef;
  height: 40px;
  border-radius: 7px;
}
.form-container .custom-form-input {
  width:100%;
  display: flex;
  flex-direction:row;
  align-items: center;
}
.form-container .custom-form-input .password{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
  /* border-right:0px; */
}
.form-container .custom-form-input .eye-icon{
  background: #efefef;
  border-radius:0px 7px 7px 0px;
  border: 2px solid rgba(230,230,230,1);
  border-left:0px;
  height:40px;
}
.login-page .form-container .ant-select {
  width: 100% !important;
  margin-bottom: 15px !important;
}
.login-page .form-container .ant-select-selector {
  height: 40px !important;
  border-radius: 5px !important;
}
.login-page .form-container .ant-select-selection-item {
  line-height: 40px !important;
}
.auth-types {
  display: flex;
  padding: 0px 25px;
  gap: 10px;
}
.auth-type {
  text-align: center;
  width: 50%;
  cursor: pointer;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 15px;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  background: #f5f8f9;
}
.auth-type:hover {
  background: #eaeaea;
  color: #222;
  border-color: #eaeaea;
}
.auth-type.active {
  background: #0fa0cf;
  color: #fff;
  border-color: #0fa0cf;
}
.footer-container {
  margin-top: 30px;
  width: 100%;
  display: grid;
  place-items: center;
}
.footer-container .footer-text {
  font-size: 14px;
  color: #000;
}
.footer-container .footer-link {
  font-size: 14px;
  color: #3366bb;
  cursor: pointer;
}
.footer-link:hover {
  text-decoration: underline;
}
.text-heading {
  font-size: 20px;
  font-weight: 500;
  color: rgb(43, 43, 43);
}

@media only screen and (max-width: 600px) {
  .auth-types {
    padding: 0px 5px;
  }
  .auth-type {
    padding: 5px;
  }
  .login-container {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/Auth/login.css"],"names":[],"mappings":"AAAA;EACE,mDAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,sCAAsC;EACtC,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,YAAY;;EAEZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".login-page {\n  background: url(./../../../Images/bg/login.jpg);\n  height: 100vh;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.login-container {\n  width: 500px;\n  position: fixed;\n  background: #fff;\n  top: 50%;\n  border-radius: 10px;\n  box-shadow: 1px 3px 20px 4px #00000012;\n  left: 50%;\n  padding: 90px 30px;\n  transform: translate(-50%, -50%);\n}\n.logo-container {\n  width: 200px;\n\n  margin: 0 auto;\n  margin-bottom: 30px;\n}\n.logo-container img {\n  max-width: 100%;\n}\n.button-container {\n  margin-top: 30px;\n}\n.button-container button {\n  color: #fff;\n  width: 100%;\n  border-radius: 7px;\n  font-size: 18px;\n  height: 50px;\n  background: #45bd5b;\n}\n.form-container input {\n  border: 2px solid rgba(230,230,230,1);\n  background: #efefef;\n  height: 40px;\n  border-radius: 7px;\n}\n.form-container .custom-form-input {\n  width:100%;\n  display: flex;\n  flex-direction:row;\n  align-items: center;\n}\n.form-container .custom-form-input .password{\n  border-top-right-radius:0px;\n  border-bottom-right-radius:0px;\n  /* border-right:0px; */\n}\n.form-container .custom-form-input .eye-icon{\n  background: #efefef;\n  border-radius:0px 7px 7px 0px;\n  border: 2px solid rgba(230,230,230,1);\n  border-left:0px;\n  height:40px;\n}\n.login-page .form-container .ant-select {\n  width: 100% !important;\n  margin-bottom: 15px !important;\n}\n.login-page .form-container .ant-select-selector {\n  height: 40px !important;\n  border-radius: 5px !important;\n}\n.login-page .form-container .ant-select-selection-item {\n  line-height: 40px !important;\n}\n.auth-types {\n  display: flex;\n  padding: 0px 25px;\n  gap: 10px;\n}\n.auth-type {\n  text-align: center;\n  width: 50%;\n  cursor: pointer;\n  padding: 10px;\n  font-size: 14px;\n  margin-bottom: 15px;\n  border-radius: 10px;\n  border: 1px solid #eaeaea;\n  background: #f5f8f9;\n}\n.auth-type:hover {\n  background: #eaeaea;\n  color: #222;\n  border-color: #eaeaea;\n}\n.auth-type.active {\n  background: #0fa0cf;\n  color: #fff;\n  border-color: #0fa0cf;\n}\n.footer-container {\n  margin-top: 30px;\n  width: 100%;\n  display: grid;\n  place-items: center;\n}\n.footer-container .footer-text {\n  font-size: 14px;\n  color: #000;\n}\n.footer-container .footer-link {\n  font-size: 14px;\n  color: #3366bb;\n  cursor: pointer;\n}\n.footer-link:hover {\n  text-decoration: underline;\n}\n.text-heading {\n  font-size: 20px;\n  font-weight: 500;\n  color: rgb(43, 43, 43);\n}\n\n@media only screen and (max-width: 600px) {\n  .auth-types {\n    padding: 0px 5px;\n  }\n  .auth-type {\n    padding: 5px;\n  }\n  .login-container {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
